import { Identifier } from '../../common/identifier';

export type _UniqueKeys = {
  customer: _UniqueKeys.Customer | undefined;
  contract: _UniqueKeys.Contract;
};
export namespace _UniqueKeys {
  /** Customer の一意キー設定 */
  export type Customer = {
    columnNames: string[];
    identifierType: Identifier.Type;
  };

  /** Contract の一意キー設定 */
  export type Contract = {
    columnNames: string[];
  };

  export type Props = {
    customer:
      | {
          columnNames: string[];
          identifierType: string;
        }
      | undefined;
    contract: {
      columnNames: string[];
    };
  };
  export const Construct = (props: Props): _UniqueKeys => ({
    customer: props.customer
      ? {
          columnNames: props.customer.columnNames,
          identifierType: Identifier.Type.FromString(props.customer.identifierType),
        }
      : undefined,
    contract: {
      columnNames: props.contract.columnNames,
    },
  });
}
